(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.target.closest('#search-button')) {
      document.querySelector('#search-container').classList.toggle('hidden');
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('#menu-toggler')) {
      document.querySelector('#mobile-menu').classList.toggle('hidden');
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('#close-searchform')) {
      document.querySelector('#search-container').classList.add('hidden');
    }
  });



  } catch(e) { console.error(e); }
})();
})();
